import { getMultipleRefCompsIdFromInflatedId, getUniqueId } from '@wix/thunderbolt-commons'
import { createConsumptionDataNode } from './utils/dataNodeUtils'
import type { Ref } from '@wix/materializer'
import type { StateVariant, TriggerVariant } from '@wix/thunderbolt-becky-types'

type RefConsumptionDependencies = Ref<TriggerVariant | StateVariant>

export const Variants = createConsumptionDataNode<null, null, RefConsumptionDependencies>({
	toViewItem: ({ id, value }) => {
		const ancestorsChain = getMultipleRefCompsIdFromInflatedId(id)
		return {
			...value,
			componentId: getUniqueId(ancestorsChain, value.componentId),
			id,
		}
	},
})
